import { render, staticRenderFns } from "./specialties.vue?vue&type=template&id=bb6ae6e4"
import script from "./specialties.vue?vue&type=script&lang=js"
export * from "./specialties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports